<template>
  <div v-if="customerQuickReporting" class="container mt-4 mb-0 pb-0 mb-md-4 pb-md-5">
   <div class="quick-list">
    <div class="quick-item">
      <i class="icon fas fa-truck"></i>
      <a class="label" href="/orders/list" style="cursor: pointer;">Commandes Livrées</a>
      <span class="count">{{ customerQuickReporting.orderCount }}</span>
    </div>

    <div class="quick-item">
      <i class="icon fas fa-coins"></i>
      <span class="label">Volume d'achat annuel </span>
      <span class="count">{{ customerQuickReporting.totalSales }}</span>
    </div>

    <div class="quick-item mb-3">
      <i class="icon fas fa-percent"></i>
      <span class="label">Remise globale</span>
      <span class="count">{{ customerQuickReporting.avgDiscount }} %</span>
    </div>

    <!-- <div class="quick-item">
      <i class="icon fas fa-hand-holding-usd"></i>
      <span class="label">Remise bénéficiée</span>
      <span class="count">{{ customerQuickReporting.totalSavings }}</span>
    </div>

    <div class="quick-item">
      <i class="icon fas fa-tags"></i>
      <span class="label">Total Remise</span>
      <span class="count">{{ customerQuickReporting.totalDiscount }}</span>
    </div>

    <div class="quick-item mb-2">
      <i class="icon fas fa-gift"></i>
      <span class="label">Total des Gratuités</span>
      <span class="count">{{ customerQuickReporting.formattedNonGratuityDiscount }}</span>
    </div> -->

  </div>

  </div>
</template>

<script>
import OrdersApi from "@/services/orders-api";

export default {
  name: "QuickShortcuts",
  data() {
    return {
      customerQuickReporting:null,
      isCustomerQuickReportingBusy:false,
    };
  },

  
  mounted() {
    this.getCustomerQuickReporting()
  },

  methods:{
    getCustomerQuickReporting(){
      this.isCustomerQuickReportingBusy = true;
      OrdersApi.getCustomerQuickReporting().then((result) => {
        this.customerQuickReporting = result;
        }).finally(() => {
          this.isCustomerQuickReportingBusy = false;
        })
    },
  }
};
</script>


<style scoped>
.quick-list {
  background: #fff;
  border-radius: 6px;
}

.quick-item {
  display: flex;
  align-items: center;
  padding: 5px 0;
  font-size: 14px;
}

.quick-item:last-child {
  border-bottom: none;
}

.icon {
  width: 30px;
  text-align: center;
  color: #555;
}

.label {
  flex: 1;
  color: #333;
}

.count {
  font-weight: bold;
  color: #000;
}
</style>